import React from "react";

import LockIcon from "@uui/Lock03";

import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";
import Stack from "@rui/Stack";

const CustomVocabularyModuleUpsell = ({
  hasVocabulary,
  planLabel,
}: {
  hasVocabulary: boolean;
  planLabel: string | null;
}) => (
  <Stack
    variant="center"
    spacing={1}
    sx={{ color: "shades.neutral.600", textAlign: "center", pt: 1 }}
  >
    <EmptyStateIcon Icon={LockIcon} padding={2} />
    <EmptyStateTitle>
      Not available{planLabel ? ` on the ${planLabel} plan` : ""}
    </EmptyStateTitle>
    {hasVocabulary ? (
      <EmptyStateSubtext>
        Upgrade to Read Pro or Enterprise to reactivate your previously-added
        custom vocabulary.
      </EmptyStateSubtext>
    ) : (
      <EmptyStateSubtext>
        To add custom words and increase transcription accuracy, upgrade to Read
        Pro or Enterprise.
      </EmptyStateSubtext>
    )}
    <Link to={ROUTES.UPGRADE_ACCOUNT}>
      <Button>Upgrade</Button>
    </Link>
  </Stack>
);

export default CustomVocabularyModuleUpsell;
